import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const contratadas_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Contratada/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Contratada/getItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Contratada`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Contratada`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default contratadas_api;
